import { http, httpSchool, apiEndPoints } from "../../utils/http";
//import { httpSchool, apiEndPoints } from "../../utils/http/http-common";
import axios from "axios";
const headers = {
  "Content-type": "multipart/form-data",
};

const getGender = () => {
  return http.get(apiEndPoints.GET_GENDER);
};

const getGrade = (languageId) => {
  return http.get(`${apiEndPoints.GET_GRADE}/${languageId}`);
};

const getStates = () => {
  return http.get(apiEndPoints.GET_STATES);
};

const getDistrictByStateId = (stateId) => {
  return http.get(`${apiEndPoints.GET_DISTRICT_BY_STATE_ID}/${stateId}`);
};

const getBlockByDistrictId = (DistrictId) => {
  return http.get(`${apiEndPoints.GET_BLOCK}/${DistrictId}`);
};

const getSchoolById = (stateId, districtId) => {
  return http.get(
    `${apiEndPoints.GET_SCHOOL_BY_DISTRICT_ID}/${stateId}/${districtId}`
  );
};

// const updateUserProfile = (data) => {
//   //return httpStaging.post(apiEndPoints.UPDATE_PROFILE, data, headers);
//   return axios.post(
//     "https://staging-api-pi.projectinclusion.in/api" +
//       apiEndPoints.UPDATE_PROFILE,
//     data,
//     headers
//   );
// };

const updateUserProfile = async (data) => {
  try {
    const response = await axios.post(
      `https://api-pi.projectinclusion.in/api${apiEndPoints.UPDATE_PROFILE}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error updating profile:", error);
    throw error;
  }
};

const updateUserProfileNoImage = (data) => {
  return http.post(apiEndPoints.UPDATE_PROFILE_NO_IMAGE, data, headers);
};

const getSchoolByUdise = (data) => {
  return http.post(apiEndPoints.GET_SCHOOL_BY_UDISE, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const getSchoolByBlockId = (blockId) => {
  return httpSchool
    .get(`${apiEndPoints.GET_SCHOOL_BY_BlockId_SchoolApi}/${blockId}`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.error("API Error:", error); //Handel api error
    });
};

const getSchoolByUdiseCode = (udiseCode) => {
  return httpSchool.get(
    `${apiEndPoints.GET_SCHOOL_BY_UDISE_SchoolApi}?udiseCode=${udiseCode}`
  );
};

const profile = {
  getGender,
  getGrade,
  getStates,
  getDistrictByStateId,
  getSchoolById,
  updateUserProfile,
  getBlockByDistrictId,
  getSchoolByUdise,
  updateUserProfileNoImage,
  getSchoolByBlockId,
  getSchoolByUdiseCode,
};

export default profile;
